import React, { Fragment } from "react";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import TRowBody from "./TRowBody";
import TBody from "./tbody";
import TButton from "./TButton";
import TUploadImage from "./TUploadImage";
const grid = 8;

const getItemStyle = (isDragging, draggableStyle) => ({
  userSelect: "none",
  padding: grid * 2,
  margin: `0 ${grid}px 0 0`,
  ...draggableStyle,
  width: isDragging ? '1140px': 'auto'
});

const getListStyle = () => ({
  padding: grid,
  overflow: "auto",
});
const TBodyDraggable = ({ tBodyProps,  onDragEnd}) => {
  return (
    <DragDropContext onDragEnd={onDragEnd} >
      <Droppable droppableId="droppable">
        {(provided, snapshot) => (
          <TBody
            innerRef={provided.innerRef}
            {...tBodyProps}
            {...provided.droppableProps}
            style={getListStyle(snapshot)}
            render={(
              columns,
              rows,
              optionsRow,
              columnDelete,
              columnUploadImages,
              onDeleteRow,
              onChangeFieldColumn,
            ) => {
              if (!Array.isArray(rows)) return null;
              return (
                <Fragment>
                  {rows.map((row, index) => (
                    <Draggable
                      key={row._id}
                      draggableId={row._id}
                      index={index}

                    >
                      {(provided, snapshot) => (
                        <TRowBody
                          innerRef={provided.innerRef}
                          {...provided.draggableProps}
                          {...provided.dragHandleProps}
                          style={getItemStyle(
                            snapshot.isDragging,
                            provided.draggableProps.style
                          )}
                          key={row._id}
                          id={row._id}
                          optionsRow={optionsRow}
                          values={columns.map((key) => [key, row[key]])}
                          onChange={(key, value) => {
                            onChangeFieldColumn(row._id, key, value);
                          }}
                        >
                          {columnDelete ? (
                            <TButton onEvent={() => onDeleteRow(row._id)} />
                          ) : null}
                          {columnUploadImages ? (
                            <TUploadImage uri={row.adminId} />
                          ) : null}
                        </TRowBody>
                      )}
                    </Draggable>
                  ))}
                  {provided.placeholder}

                </Fragment>
              );
            }}
          >
          </TBody>
        )}
      </Droppable>
    </DragDropContext>
  );
};

export default TBodyDraggable;



// WEBPACK FOOTER //
// ./src/new-components/admin/table/TBodyDraggable.js